import React, { ChangeEvent, useState } from "react";
import { FaRegEye } from "react-icons/fa6";
import { FaRegEyeSlash } from "react-icons/fa6";

interface InputProps {
  label: string;
  placeholder: string;
  value?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  type?: string;
  name?: string;
  autoFocus?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  required?: boolean;
  testId?: string;
  requireIcon?: boolean;
  autoComplete?:string;
}

const InputField: React.FC<InputProps> = ({
  type,
  label,
  placeholder,
  value,
  onChange,
  onKeyDown,
  name,
  autoFocus,
  readonly,
  disabled,
  required = true,
  testId,
  requireIcon,
  autoComplete
}) => {
  const [fieldtype, setfieldtype] = useState(type);
  const iduniqe = Date.now();

  const togglePass = () => {
    setfieldtype(fieldtype === "password" ? "text" : "password");
  };

  return (
    <>
      <label className="block mb-2 text-sm font-medium text-gray-500 dark:text-white">
        {label} {requireIcon && <span className="text-red-600">*</span>}
      </label>
      <div className="relative">
        <input
          data-testId={testId}
          disabled={disabled}
          name={name}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          type={type ? (type === "password" ? fieldtype : type) : "text"}
          id={label + iduniqe}
          className={`block w-full p-2.5 text-sm text-gray-900 rounded-lg bg-[#F6F6F6] ${readonly ? "focus:ring-0 focus:border-0" : ""
            } focus:outline-none focus:ring focus:border-blue-100 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${type === "password" ? "pr-10" : ""
            }`}
          placeholder={placeholder}
          required={required}
          autoFocus={autoFocus ? true : false}
          readOnly={readonly ? true : false}
          autoComplete={autoComplete}
        />
        <div className="absolute right-3 top-3">
          {type === "password" &&
            (fieldtype === "password" ? (
              <FaRegEye onClick={togglePass} style={{ cursor: "pointer" }} />
            ) : (
              <FaRegEyeSlash
                onClick={togglePass}
                style={{ cursor: "pointer" }}
              />
            ))}
        </div>
      </div>
    </>
  );
};

export default InputField;
